import { OrderStatusTone } from "@app/domain";

/** Central place mapping a semantic status tone to a text color — the plain-
 * text counterpart to `statusToneIcon`, used wherever status is shown as
 * colored text rather than a `StatusPill` (e.g. Home page's status line). */
export function statusToneColor(tone: OrderStatusTone): string {
  switch (tone) {
    case "neutral":
      return "var(--color-neutral)";
    case "pending":
      return "var(--color-pending)";
    case "warning":
      return "var(--color-warning)";
    case "assigned": 
      return "var(--color-assigned)";
    case "primary": 
      return "var(--color-status-primary)";
    case "info":
      return "var(--color-info)";
    case "success":
      return "var(--color-success)";
    case "danger":
      return "var(--color-danger)";
    default:
      return "var(--color-text-secondary)";
  }
}
